export const teamManagement = {
  forbidden: {
    title: "Zugriff eingeschränkt",
    desc: "Nur der Haupt-Gastgeber kann das Team verwalten.",
  },
  header: {
    title: "Teamverwaltung",
    subtitle: "Legen Sie fest, wer auf das Dashboard Ihrer Unterkunft zugreifen darf",
    addMember: "Mitglied hinzufügen",
  },
  stats: {
    totalTeam: "Team gesamt",
    host: "Gastgeber",
    additionalMembers: "Weitere Mitglieder",
  },
  search: {
    placeholder: "Nach Name oder E-Mail suchen…",
  },
  loading: "Team wird geladen…",
  table: {
    member: "Mitglied",
    email: "E-Mail",
    role: "Rolle",
    properties: "Unterkünfte",
    added: "Hinzugefügt",
    actions: "Aktionen",
    ownerBadge: "Gastgeber",
    mainHost: "Haupt-Gastgeber",
    viewPermissions: "Erlaubte Funktionen ansehen",
    allProperties: "Alle",
    unassigned: "Nicht zugewiesen",
    notEditable: "Nicht bearbeitbar",
    edit: "Bearbeiten",
    delete: "Löschen",
  },
  surfaces: {
    web: "Web",
    app: "App",
  },
  empty: {
    title: "Keine weiteren Mitglieder",
    desc: "Über die Schaltfläche <strong>Mitglied hinzufügen</strong> laden Sie Personen in Ihr Team ein.",
  },
  infoBanner:
    "Teammitglieder melden sich mit eigenem Benutzernamen und Passwort am Dashboard an. Jedes Profil hat feste Berechtigungen, und der Datenzugriff wird auf dem Server durchgesetzt. Eigentümer melden sich nur über das Web an, Reinigung und Wartung nur über die App. Der <strong>Haupt-Gastgeber</strong> hat immer vollen Zugriff und kann nicht entfernt werden.",
  modal: {
    createTitle: "Mitglied hinzufügen",
    editTitle: "Mitglied bearbeiten",
    nameLabel: "Vollständiger Name",
    namePlaceholder: "Z. B. Maria Garcia",
    emailLabel: "E-Mail-Adresse",
    emailPlaceholder: "email@beispiel.com",
    roleLabel: "Zugriffsprofil",
    viewScope: "Sichtbarkeitsbereich",
    accessIncluded: "Enthaltener Zugriff",
    assignedProperties: "Zugewiesene Unterkünfte",
    selectedCount: "({selected} von {total} ausgewählt)",
    propertySearchPlaceholder: "Unterkunft suchen…",
    selectAll: "Alle auswählen",
    clear: "Leeren",
    noResults: 'Keine Ergebnisse für „{query}“',
    selectAtLeastOneHint: "Wählen Sie mindestens eine Unterkunft für dieses Profil aus.",
    noPropertiesWarning:
      "Es sind keine Unterkünfte zum Zuweisen verfügbar. Legen Sie eine Unterkunft an, bevor Sie dieses Profil speichern.",
    passwordLabel: "Passwort",
    passwordOptional: "(leer lassen, um es beizubehalten)",
    passwordPlaceholder: "Mindestens 8 Zeichen",
    confirmPasswordLabel: "Passwort bestätigen",
    confirmPasswordPlaceholder: "Passwort wiederholen",
    showPassword: "Passwort anzeigen",
    hidePassword: "Passwort verbergen",
    cancel: "Abbrechen",
    create: "Mitglied anlegen",
    save: "Änderungen speichern",
  },
  deleteModal: {
    title: "Mitglied löschen",
    subtitle: "Diese Aktion kann nicht rückgängig gemacht werden",
    confirm:
      "Möchten Sie {name} wirklich aus dem Team entfernen? Der Zugriff auf das Dashboard geht sofort verloren.",
    cancel: "Abbrechen",
    delete: "Löschen",
  },
  roleInfo: {
    defaultTitle: "Berechtigungen",
    description:
      "Dieses Profil ist fest vorgegeben. Sichtbarkeitsbereich, Zugriffsweg und Unterkünfte werden zusätzlich auf dem Server geprüft.",
    understood: "Verstanden",
  },
  roleDescriptions: {
    anfitrion: "Voller Zugriff auf alle Unterkünfte über Web und App.",
    propietario:
      "Kalender und Auswertungen nur für die zugewiesenen Unterkünfte. Zugriff über das Web.",
    limpieza:
      "Reinigung starten, Aufgaben und Nachrichten für die eigenen Unterkünfte. Nur App.",
    mantenimiento:
      "Wartung starten, Aufgaben und Nachrichten für die eigenen Unterkünfte. Nur App.",
    fallback: "Kompatibilitätsprofil mit eingeschränktem Zugriff.",
  },
  optionalHints: {
    messages:
      "Chats der eigenen Unterkünfte ansehen und beantworten. Ist die Option aus, sind weder Nachrichten noch deren Benachrichtigungen sichtbar.",
  },
  toasts: {
    loadError: "Das Team konnte nicht geladen werden.",
    memberAdded: "✓ Mitglied zum Team hinzugefügt.",
    memberUpdated: "✓ Mitglied aktualisiert.",
    saveError: "Speichern nicht möglich. Bitte versuchen Sie es erneut.",
    memberDeleted: "Mitglied aus dem Team entfernt.",
    deleteError: "Das Mitglied konnte nicht entfernt werden.",
  },
};
